import { render, staticRenderFns } from "./DeleteDownloadSettingsModal.vue?vue&type=template&id=72a1c800"
import script from "./DeleteDownloadSettingsModal.vue?vue&type=script&lang=js"
export * from "./DeleteDownloadSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports